// TODO: GET RID OF THIS FILE AND STORE ACCESS TOKEN SOMEWHERE ELSE

// import { history } from "../Redux/Reducers/history";
// import { store } from "../Redux/Reducers/AppContext";
// import { AppMetricaProvider } from "../AppMetrica/AppMetrica";

// For Configuration
if (localStorage.languageCode == undefined) {
  // Please visit this link to get your html code  https://html-css-js.com/html/character-codes/currency/
  localStorage.currencyCode = "RUB"; // Default Currency Code
  localStorage.currencyPos = "left"; // Default Currency Position
  localStorage.decimals = 2; // Default Currecny Decimal
  localStorage.currencyRate = 1; // Default Curren Rate
  localStorage.currency = "&#8381;"; // Default currecny html code to show in app.

  // Default Language Code
  localStorage.languageCode = "ru"; // For Language Arabic (ar)

  // Default Language Direction Of App
  localStorage.languageDirection = "ltr"; // For Right Direction (rtl)

  // Default Mode Theme Of App
  localStorage.modeTheme = "light"; // For Dark Mode (dark)

  // Default Side Menu Navigation
  localStorage.tabsNavigation = false; // For Tabs Navigation (true)
}

export const WooComAPI = {
  url: process.env.REACT_APP_PARHATO_URL!,
  accessToken: "",
  version: "wc/v3", // WooCommerce WP REST API version

  productsArguments: "stock_status=instock&min_price=0.1",

  getWoo(url: string) {
    url = getUrl("get", url);
    return getDataHttp(url);
  },
  getWithUrl(url: string) {
    return getDataHttp(url);
  },
  postAsync(url: string, dataToPost: any) {
    url = getUrl("post", url);
    return postDataHttp(url, dataToPost);
  },
  putAsync(url: string, dataToPost: any) {
    url = getUrl("put", url);
    return putDataHttp(url, dataToPost);
  },

  setAccessToken(token: string) {
    this.accessToken = token;
  },

  getBearerAuthToken(): string {
    return WooComAPI.accessToken ? `Bearer ${WooComAPI.accessToken}` : "";
  },
};

const getUrl = (type: string, endpoint: string) => {
  return `${WooComAPI.url}/wp-json/${WooComAPI.version}/${endpoint}`;
};

const getRequestHeaders = () => {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set("Content-Type", "application/json");
  const authToken = WooComAPI.getBearerAuthToken();

  if (authToken) {
    requestHeaders.set("Authorization", authToken);
  }

  return requestHeaders;
};

const getDataHttp = (url: string) => {
  const makeRequest = () =>
    fetch(url, {
      method: "GET",
      headers: getRequestHeaders(),
    });

  return makeRequest();
};

const putDataHttp = (url: string, dataToPost: any) => {
  const makeRequest = () =>
    fetch(url, {
      method: "PUT",
      body: JSON.stringify(dataToPost),
      headers: getRequestHeaders(),
    });

  return makeRequest();
};

const postDataHttp = (url: string, dataToPost: any) => {
  const makeRequest = () =>
    fetch(url, {
      method: "POST",
      body: JSON.stringify(dataToPost),
      headers: getRequestHeaders(),
    });

  return makeRequest();
};

// const catchInvalidTokenError = async (response: Response, makeRequest: () => Promise<Response>): Promise<any> => {
//   if (!response.ok) {
//     const data = await response.json();

//     AppMetricaProvider.reportError(response.statusText, JSON.stringify(data));

//     const jwtErrors = ["jwt_auth_invalid_token", "jwt_auth_user_not_found", "jwt_auth_obsolete_token"];

//     if (jwtErrors.includes(data.code)) {
//       store.dispatch({
//         type: "REMOVE_CUSTOMER_DATA",
//       });
//       history.replace("/home3");

//       const res = await makeRequest();
//       return res.json();
//     } else {
//       return Promise.reject({ message: data.message, error: data });
//     }
//   }

//   return response.json();
// };

export default WooComAPI;
